import React from "react";
import { GET_FILE_UPLOAD } from "api/ApiConstants";

const FlightTicketContactDetails = (props) => {
  return (
    <>
      <div className="flex-box ticket-row contact-details-row">
        <div
          className="ticket-col contact-details-table-col w100p"
          style={{ width: "100%" }}
        >
          <table className="contact-details-table" style={{ width: "100%" }}>
            <thead>
              <tr style={{ backgroundColor: "#eee" }}>
                <th style={{ textAlign: "center" }}>Airline Contact Detail</th>
              </tr>
            </thead>
          </table>
          <table className="contact-details-table" style={{ width: "100%" }}>
            <tbody>
              <tr style={{ backgroundColor: "#FAFAFA" }}>
                <td>
                  <div className="contact-img-wrapper">
                    <img
                      style={{ height: 30, width: 30, marginLeft: 20 }}
                      src={
                        GET_FILE_UPLOAD +
                        "?fileName=" +
                        (props.journeyType === "return"
                          ? props.data?.returnJourney[0]?.flightName
                          : props.data?.onwardJourney[0]?.flightName) +
                        ".png" +
                        "&type=AIRLINE_IMAGES"
                      }
                      alt={
                        (props.journeyType === "return"
                          ? props.data?.returnJourney[0]?.flightName
                          : props.data?.onwardJourney[0]?.flightName) + " icon"
                      }
                    />
                  </div>
                </td>
                <td style={{ textAlign: "center" }}>
                  {props.journeyType === "return"
                    ? props.data?.returnJourney[0]?.tollfree !== ""
                      ? props.data.returnJourney[0].tollfree
                      : props.data.returnJourney[0].carrierTollFreeNo
                    : props.data?.returnJourney[0]?.tollfree !== ""
                    ? props.data.onwardJourney[0].tollfree
                    : props.data.onwardJourney[0].carrierTollFreeNo}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      {!props.state?.isAddressHide && props.data.agentInfo && (
        <div className="flex-box ticket-row contact-details-row">
          <div
            className="ticket-col contact-details-table-col w100p"
            style={{ width: "100%" }}
          >
            <table className="contact-details-table" style={{ width: "100%" }}>
              <thead style={{ backgroundColor: "#eee" }}>
                <tr>
                  <th style={{ textAlign: "center" }}>Contact Detail</th>
                </tr>
              </thead>
              <tbody style={{ backgroundColor: "#FAFAFA" }}>
                <tr style={{ textAlign: "center" }}>
                  <td>
                    {props.data.agentInfo?.agentAddress},{" "}
                    {props.data.agentInfo?.agentCity}
                    <br />
                    {props.data.agentInfo?.agentState},
                    {props.data.agentInfo?.agentCountry},{" "}
                    {props.data.agentInfo?.agentPincode}
                  </td>
                </tr>
                <tr style={{ textAlign: "center" }}>
                  <td>
                    Email:{" "}
                    <span className="email-span">
                      {props.data.agentInfo?.agentEmail}
                    </span>{" "}
                    | Phone: {props.data.agentInfo?.agentMobileNumber}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      )}
    </>
  );
};

export default FlightTicketContactDetails;
